var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"db18e36de77bb218d571eb2aa512cae7eb819672"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blankly-platform@blankly-finance"]={id:"db18e36de77bb218d571eb2aa512cae7eb819672"};
      